import * as index from '@syncfusion/ej2-pivotview';
index.PivotView.Inject( index.GroupingBar,index.FieldList,index.CalculatedField);
export * from '@syncfusion/ej2-pivotview';
